import { attr, Model } from 'redux-orm';
import { createAction, createLoadConst } from '../util';

export default class PayerAudit extends Model {
  static get modelName() {
    return 'PayerAudit';
  }

  static reducer({ type, data }, PayerAudit) {
    switch (type) {
      case LOAD.SUCCESS:
        PayerAudit.delete();
        if (data.response) {
          data.response.forEach((r) => PayerAudit.upsert(r));
        }
        break;

      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      byAdminUserId: attr(),
      bySystemUser: attr(),
      byUserId: attr(),
      changelog: attr(),
      id: attr(),
      logAt: attr(),
      logId: attr(),
      logOp: attr(),
      time: attr(), // derived
      title: attr(), // derived
    };
  }
}

export const LOAD = createLoadConst(PayerAudit.modelName);
export const load = createAction(LOAD);
